exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lts-1 {\n    fill: #fbe57f;\n  }\n\n.lts-2 {\n    fill: #001927;\n  }\n\n.lts-3 {\n    fill: #72cac2;\n  }\n", ""]);
